/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbUpIcon16Solid = forwardRef('HandThumbUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 6 8.613.58A1.303 1.303 0 0 1 11 1.303V5h2.938a2 2 0 0 1 1.94 2.485l-1.31 5.243A3 3 0 0 1 11.658 15H5V6Z" }),
        React.createElement("path", { d: "M2 6a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2V6H2Z" })));
});
